import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { VisitsListProvider, VisitsProvider } from '../../contexts';
import { SidebarLayout } from '../../layouts';
import { PermissionsGuard } from './Components';
import { Loader } from './loader.routes';

const VisitList = Loader(lazy(() => import('../../content/pages/Visits/VisitList')));
const VisitDetails = Loader(lazy(() => import('../../content/pages/Visits/VisitDetails')));

export const createVisitsRoutes = () => ({
  path: 'visits',
  element: <SidebarLayout />,
  children: [
    {
      path: '',
      element: (
        <PermissionsGuard allowedPermissions={['visitViewAll', 'visitViewAllClient', 'visitViewAllVenue']} should404>
          <Navigate to="/visits/list" replace />
        </PermissionsGuard>
      )
    },
    {
      path: 'list',
      element: (
        <PermissionsGuard allowedPermissions={['visitViewAll', 'visitViewAllClient', 'visitViewAllVenue']} should404>
          <VisitsListProvider>
            <VisitList />
          </VisitsListProvider>
        </PermissionsGuard>
      )
    },
    {
      path: `:visitId/`,
      element: (
        <PermissionsGuard allowedPermissions={['visitViewAll', 'visitViewAllClient', 'visitViewAllVenue']} should404>
          <VisitsProvider>
            <VisitDetails />
          </VisitsProvider>
        </PermissionsGuard>
      )
    }
  ]
});
